<template>
<div id="product-price-ranger" class="menu" v-if="ranges && ranges.length > 0">
    <h2 class="menu-label">Price</h2>
    <ul class="menu-list">
        <li>
            <label class="radio"><input type="radio" name="picked_range" v-model="picked_range" :value="null" />All Prices</label>
        </li>
        <li v-for="range in ranges">
            <label class="radio"><input type="radio" name="picked_range" v-model="picked_range" :value="range.from + ':' + range.to" />{{range.from.toDollar()}} - {{range.to.toDollar()}}</label>
        </li>
    </ul>
</div>
</template>

<script>
import QueryMixin from '../mixins/QueryMixin';
export default {
    name        :   'ProductPriceRanger',
    props       :   ['ranges'],
    mixins      :   [ QueryMixin ],
    data()
    {
        return {
            price_from      :   this.$route.query.price_from ? this.$route.query.price_from : null,
            price_to        :   this.$route.query.price_to ? this.$route.query.price_to : null,
            picked_range    :   this.default_range()
        };
    },
    methods     :   {
        default_range()
        {
            if (this.$route.query.price_from != null && this.$route.query.price_to != null) {
                return this.$route.query.price_from + ':' + this.$route.query.price_to;
            }

            return null;
        }
    },
    watch       :   {
        picked_range(nv, ov)
        {
            if (nv) {
                let segments    =   nv.split(':');
                this.price_from =   segments[0];
                this.price_to   =   segments[1];
            } else {
                this.price_from =   null;
                this.price_to   =   null;
            }

            this.$router.push({query: this.make_query(null, false, !this.price_from && !this.price_to)});
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/ProductPriceRanger.vue